/* SHOP PAGE — banner video (plays only while on screen) and ADD TO CART on the posters. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var video = document.querySelector('[data-nhp-shop-video]');
  var pause = document.querySelector('[data-nhp-shop-pause]');

  if (video && pause) {
    var wanted = !reduce;            // what the viewer asked for
    var onScreen = false;

    function apply() {
      if (wanted && onScreen) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      else video.pause();
      pause.setAttribute('aria-pressed', wanted ? 'false' : 'true');
      pause.querySelector('.nhp-sr').textContent = wanted ? 'Pause the video' : 'Play the video';
    }

    pause.addEventListener('click', function () { wanted = !wanted; apply(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        apply();
      }, { threshold: 0.2 }).observe(video);
    } else {
      onScreen = true;
      apply();
    }
    // never burn battery on a hidden tab
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause(); else apply();
    });
    if (reduce) video.removeAttribute('loop');
  }

  /* The posters light up as they scroll in, one at a time, 260ms apart — the same marquee flicker as the
     homepage (Jay, 2026-09-30; they used to render already lit). No observer or reduced motion: all lit. */
  var posters = Array.prototype.slice.call(document.querySelectorAll('.nhp-shop [data-nhp-poster]'));
  if (reduce || !('IntersectionObserver' in window)) {
    posters.forEach(function (p) { p.classList.add('is-lit'); });
  } else {
    var queue = [];
    var timer = null;
    var release = function () {
      var next = queue.shift();
      if (!next) { timer = null; return; }
      next.classList.add('is-lit');
      timer = setTimeout(release, 260);
    };
    var lightObs = new IntersectionObserver(function (entries) {
      entries
        .filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return posters.indexOf(a.target) - posters.indexOf(b.target); })
        .forEach(function (e) { lightObs.unobserve(e.target); queue.push(e.target); });
      if (!timer) release();
    }, { threshold: 0.4 });
    posters.forEach(function (p) { lightObs.observe(p); });
    // a fast fling (or a jump link) can carry a poster from below the screen to above it between two
    // frames — it never crosses 40%, so it would stay dark when you scroll back up. Light what's passed.
    var passing = false;
    window.addEventListener('scroll', function () {
      if (passing) return;
      passing = true;
      setTimeout(function () {
        passing = false;
        posters.forEach(function (p) {
          if (!p.classList.contains('is-lit') && p.getBoundingClientRect().bottom < 0) {
            lightObs.unobserve(p);
            p.classList.add('is-lit');
          }
        });
      }, 200);
    }, { passive: true });
  }

  /* the posters' ADD TO CART (the homepage's handler lives in nhp-now-showing.js, which this page
     does not load) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nhp-shop [data-nhp-add]');
    if (!btn || !window.NNCart) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    window.NNCart.addAndOpen(btn.getAttribute('data-nhp-add'), 1)
      .then(function () { btn.textContent = label; })
      .catch(function () { btn.textContent = 'TRY AGAIN'; })
      .then(function () { btn.disabled = false; });
  });
})();
